export default __webpack_public_path__ + "static/media/AngleRight.225d296e.svg";